import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Form, Col, Row, Button } from '_zari/core'

import { EstadosOSE } from 'constants/index'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

import * as FormGroups from './formGroups'
import ValidationSchema from './validacion'

// import { DateHandler } from 'utils'

const FiltrosSection = ({ innerRef, actualizarListaDocumentos }) => {
  const __zariContext = React.useContext(ZariContext)

  React.useEffect(() => {
    __zariContext.loader.open('Obteniendo fechas de documentos pendientes.')
    // const fechaHasta = new Date()
    // fechaHasta.setHours(5, 0, 0)
    // let fechaDesde = fechaHasta
    // const mesActual = fechaHasta.getMonth()
    // const anioActual = fechaHasta.getFullYear()
    // if (mesActual === 0 || mesActual === 11) {
    //   fechaDesde = new Date(anioActual, 0, 1)
    // } else {
    //   fechaDesde = new Date(anioActual, mesActual - 1, 1)
    // }
    // if (innerRef.current) {
    //   innerRef.current.setFieldValue('fechaDesde', DateHandler.format(fechaDesde))
    //   innerRef.current.setFieldValue('fechaHasta', DateHandler.format(fechaHasta))
    // }
    // __zariContext.loader.close()

    FacturacionHistorialService.obtenerFechaPrimerPendienteEmisorComprobantesElectronicos()
      .then(({ data }) => {
        if (innerRef.current) {
          innerRef.current.setFieldValue('fechaDesde', data.fechaDesde)
          innerRef.current.setFieldValue('fechaHasta', data.fechaHasta)
        }
      })
      .catch(() => {
        __zariContext.toast('error', 'No se ha podido obtener las fechas de los documentos.')
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, innerRef])

  const formInitialValues = React.useMemo(() => {
    return {
      ruc: '',
      razonSocial: '',
      serieDocumento: '',
      numeroDocumento: '',
      fechaDesde: '',
      fechaHasta: '',
      tipoDocumento: '',
      estado: EstadosOSE.PENDIENTE,
      flagFiltrosAvanzados: false
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Consultando documentos ...')

      let filtros = {
        fechaDesde: data.fechaDesde,
        fechaHasta: data.fechaHasta,
        tipoDocumento: data.tipoDocumento,
        estadoOSE: data.estado
      }

      if (data.flagFiltrosAvanzados) {
        filtros = {
          ruc: data.ruc,
          razonSocial: data.razonSocial,
          serieDocumento: data.serieDocumento,
          numeroDocumento: data.numeroDocumento
        }
      }

      FacturacionHistorialService.obtenerAsEmisor(filtros)
        .then(({ data }) => {
          if (data && data.length === 0) {
            __zariContext.toast('warning', 'No se encontraron documentos con los filtros indicados')
          }

          actualizarListaDocumentos(data.map(x => ({ ...x, checked: false })))
        })
        .catch(() => {
          __zariContext.snack('error', 'No se pudo obtener los documentos solicitados.')
          actualizarListaDocumentos([])
        })
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext, actualizarListaDocumentos]
  )

  return (
    <>
      <Formik innerRef={innerRef} initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
        {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
          <Form>
            <Row>
              {values.flagFiltrosAvanzados ? (
                <>
                  <Col sm={6} md={5} xl={3}>
                    <FormGroups.RucFormGroup fIsSubmitting={isSubmitting} iError={errors.ruc} iTouched={touched.ruc} />
                    <FormGroups.RazonSocialFormGroup fIsSubmitting={isSubmitting} iError={errors.razonSocial} iTouched={touched.razonSocial} />
                  </Col>
                  <Col sm={6} md={5} xl={3}>
                    <FormGroups.SerieDocumentoFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.serieDocumento}
                      iTouched={touched.serieDocumento}
                    />
                    <FormGroups.NumeroDocumentoFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.numeroDocumento}
                      iTouched={touched.numeroDocumento}
                    />
                  </Col>
                </>
              ) : (
                <>
                  <Col sm={6} md={5} xl={3}>
                    <FormGroups.FechaDesdeFormGroup onChange={(value) => {
                      setFieldValue('fechaDesde', value.target.value)
                      setFieldValue('fechaHasta', value.target.value)
                    }} fIsSubmitting={isSubmitting} iError={errors.fechaDesde} iTouched={touched.fechaDesde} />
                    <FormGroups.FechaHastaFormGroup fIsSubmitting={isSubmitting} iError={errors.fechaHasta} iTouched={touched.fechaHasta} />
                  </Col>
                  <Col sm={6} md={5} xl={3}>
                    <FormGroups.TipoDocumentoFormGroup fIsSubmitting={isSubmitting} iError={errors.tipoDocumento} iTouched={touched.tipoDocumento} />
                    <FormGroups.EstadoFormGroup fIsSubmitting={isSubmitting} iError={errors.estado} iTouched={touched.estado} />
                  </Col>
                </>
              )}
              <Col md={2}>
                <Row>
                  <Col sm={6} md={12}>
                    <FormGroups.FlagFiltrosAvanzadosFormGroup fIsSubmitting={isSubmitting} iValue={values.flagFiltrosAvanzados} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={4} sm={12} />
                  <Col xs={8} sm={12}>
                    <Button onClick={handleSubmit} block disabled={isSubmitting}>
                      Consultar
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default React.memo(FiltrosSection)
